var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-200h50.46l409.46-409.46-50.46-50.46L200-250.46zm-60 60v-135.38l570-569.54 134.31 136.77L275.38-140zm620-569.77L709.77-760zm-125.75 75.52-24.79-25.67 50.46 50.46z"
  })));
};
export default SvgEdit;